import React, { useEffect, useState } from "react";
import { ForwardedTextInput } from "../../../components/DesignSystem";

type Props = {
  setAmount: (value: number) => void;
  amount: number;
  onFocus: () => void;
};

const CustomAmountInput: React.FC<Props> = ({ setAmount, amount, onFocus }) => {
  const [text, setText] = useState<string>("");

  return (
    <ForwardedTextInput
      size="large"
      prefix="$"
      placeholder={text === "" ? "0.00" : Number(amount)?.toFixed?.(2)}
      keyboardType="decimal-pad"
      value={text}
      maxNumber={999999.99}
      onChangeText={(num) => {
        // Remove any non-numeric characters except decimal point
        const formattedNum = num.replace(/[^0-9.]/g, "");

        // Check if there's more than one decimal point
        if ((formattedNum.match(/\./g) || []).length <= 1) {
          setText(formattedNum);
          // Only parse to float if the string is not empty and not just a period
          if (formattedNum && formattedNum !== ".") {
            setAmount(parseFloat(formattedNum));
          } else {
            setAmount(0);
          }
        }
      }}
      onFocus={() => {
        onFocus();
        setAmount(0);
        setText("");
      }}
      onBlur={() => {
        if (text === "" || isNaN(Number(text))) {
          setText("0");
          setAmount(0);
        } else {
          const formattedValue = parseFloat(text).toFixed(2);
          setText(formattedValue);
          setAmount(parseFloat(formattedValue));
        }
      }}
    />
  );
};

export default CustomAmountInput;
